import { Injectable } from '@angular/core';
import { DatabaseService } from './base/database.service';
import { TranslateService } from '@ngx-translate/core';

export interface LegalTerm {
  id: string;
  type: 'TERMS_OF_USE' | 'PRIVACY_POLICY';
  content: string;
  status: 'LIVE' | 'DRAFT' | 'INACTIVE';
  language: 'EN' | 'PT';
  created_at?: string;
  updated_at?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LegalTermsService extends DatabaseService<LegalTerm> {
  constructor(private translateService: TranslateService) {
    super('cp_terms_of_use');
  }

  /**
   * Busca os termos legais baseado no tipo e idioma atual do usuário
   * @param type Tipo do termo: 'TERMS_OF_USE' ou 'PRIVACY_POLICY'
   * @returns O conteúdo do termo ou null se não encontrado
   */
  async getLegalTermsByType(
    type: 'TERMS_OF_USE' | 'PRIVACY_POLICY'
  ): Promise<string | null> {
    try {
      // Obtém o idioma atual do usuário (pt ou en)
      const currentLang = this.translateService.currentLang?.toLowerCase() || 'en';
      const language = currentLang === 'pt' ? 'PT' : 'EN';

      const { data, error } = await this.supabase
        .from(this.table)
        .select('content')
        .eq('type', type)
        .eq('status', 'LIVE')
        .eq('language', language)
        .order('publish_start', { ascending: false })
        .limit(1)
        .single();

      if (error) {
        console.error('Error fetching legal terms:', error);
        return null;
      }

      return data?.content || null;
    } catch (error) {
      console.error('Error in getLegalTermsByType:', error);
      return null;
    }
  }

  /**
   * Busca os Termos de Uso baseado no idioma atual
   */
  async getTermsOfUse(): Promise<string | null> {
    return this.getLegalTermsByType('TERMS_OF_USE');
  }

  /**
   * Busca a Política de Privacidade baseada no idioma atual
   */
  async getPrivacyPolicy(): Promise<string | null> {
    return this.getLegalTermsByType('PRIVACY_POLICY');
  }
}
